import React from "react";
import "./TopBar.css";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";

const TopBar = () => {
  return (
    <div className="topbar">
      <div className="topbar-left">
        <span>
          <FaPhoneAlt />  +91 9112915891
        </span>
        <span>
          <FaEnvelope /> info@vezrontechnologies.com
        </span>
      </div>
      <div className="topbar-time">
        <span>
          <FaClock /> Mon – Sat 8:00 AM – 5:00 PM
        </span>
      </div>

      <div className="topbar-right">
        <a
          href="https://www.facebook.com/profile.php?id=61575025443739"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <FaFacebookF />
        </a>
        <a
          href="https://www.linkedin.com/company/vezron-technologies/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
        >
          <FaLinkedinIn />
        </a>
      </div>
    </div>
  );
};

export default TopBar;
